import React from 'react';

const CodeIcon = ({ className = "h-8 w-8", ...props }) => {
  return (
    <svg
      viewBox="0 0 100 100"
      fill="currentColor"
      className={className}
      {...props}
    >
      {/* Circle with speech bubble tail */}
      <path
        d="M50 11.026c-21.525 0-38.974 17.449-38.974 38.974 0 12.283 5.688 23.232 14.567 30.376l-14.567 8.599H50c21.525 0 38.975-17.449 38.975-38.975C88.975 28.475 71.523 11.026 50 11.026z"
        fill="currentColor"
      />
      {/* Left bracket < */}
      <path
        d="M38.165 60.521c0.581 0.581 0.581 1.521 0 2.103-0.581 0.581-1.521 0.581-2.102 0L24.516 51.076c-0.581-0.581-0.581-1.521 0-2.102l11.547-11.547c0.581-0.581 1.522-0.581 2.102 0 0.581 0.58 0.581 1.521 0 2.102L27.669 50.025 38.165 60.521z"
        fill="white"
      />
      {/* Slash / */}
      <path
        d="M56.854 38.539L45.851 62.692c-0.249 0.548-0.789 0.871-1.353 0.871-0.206 0-0.415-0.044-0.615-0.134-0.747-0.342-1.077-1.223-0.737-1.97l11.004-24.153c0.34-0.747 1.221-1.077 1.968-0.736C56.865 36.911 57.194 37.792 56.854 38.539z"
        fill="white"
      />
      {/* Right bracket > */}
      <path
        d="M75.484 51.076L63.938 62.623c-0.581 0.581-1.522 0.581-2.103 0-0.581-0.58-0.581-1.521 0-2.102l10.496-10.496L61.835 39.529c-0.581-0.581-0.581-1.521 0-2.102s1.521-0.581 2.103 0l11.547 11.547C76.065 49.555 76.065 50.496 75.484 51.076z"
        fill="white"
      />
    </svg>
  );
};

export default CodeIcon;